<template>
  <iframe
    v-if="token && isLicensesAllowed(partnerInfo)"
    :src="`${iframeBaseUrl}/pptoken/${token}?landingPage=${$route.meta.landingPage}`"
    class="embedded-full extranet licenses"
  ></iframe>
  <c-box v-else-if="!isLicensesAllowed(partnerInfo)" m="3xl">
    <c-heading as="h3">{{ $t("dialog.forbiddenOperation.title") }}</c-heading>
    <c-text mt="xl" mb="xl">{{ $t("common.blockedInfo") }}</c-text>
    <ContactPerson></ContactPerson>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { CBox, CHeading, CText } from "@chakra-ui/vue";
import ContactPerson from "@/components/ContactPerson.vue";
import { BlockableActivity } from "@iloq/shared";

export default defineComponent({
  name: "SubscriptionIframe",
  components: { CBox, CHeading, ContactPerson, CText },
  computed: {
    ...mapState("iframes", { iframeBaseUrl: "saabIframeBaseUrl" }),
    ...mapState("partnerInfo", {
      partnerInfo: "partnerInfo",
    }),
  },
  data() {
    return { token: "" };
  },
  mounted() {
    this.getFreshToken();
  },
  methods: {
    isLicensesAllowed: (partnerInfo?: any): boolean => {
      if (partnerInfo) {
        return !partnerInfo.blockedActivities?.includes(BlockableActivity.INVOICING);
      }
      return false;
    },
    async getFreshToken() {
      this.token = "";
      this.token = await this.$store.dispatch("fetchDownloadToken");
    },
  },
  watch: {
    // Token is short-lived and needs to be refreshed when moving from one subscription page to another
    "$route.meta.landingPage": function () {
      this.getFreshToken();
    },
    // ...or when refreshing current subscription page (clicking the nav item empties and re-sets saabIframeBaseUrl)
    iframeBaseUrl: function () {
      if (this.iframeBaseUrl.includes("http")) {
        this.getFreshToken();
      } else {
        this.token = "";
      }
    },
  },
});
</script>
